<template>
  <div class="item" :class="production.checked ? 'checked' : ''">
    <img :src="productionData.picture + parameters" alt="藏品" @click="info('/portfolioInfo')" />
    <!-- <el-checkbox v-if="attributes.checked" v-model="production.checked"></el-checkbox> -->
    <div class="monban flex-start-center" @click="info('/portfolioInfo')">
      <img :src="productionData.mark + parametersHead" alt="头像" class="head-img" />
      <p class="name flex-start-center">
        {{ productionData.collectionName }}
        <el-tooltip class="" effect="dark" content="官方已认证" placement="top">
          <div class="flex-center-center">
            <img v-if="productionData.addV == 1" src="@/assets/images/icon/v-icon.png" class="v-icon" alt="v" />
          </div>
        </el-tooltip>
      </p>
      <p class="user">by {{ productionData.nickName }}</p>
      <p class="dis layout y-center">
        <span>共{{ productionData.totalNftNum || productionData.nftNum  || 0}}个藏品 <span v-if="productionData.consignmentNum">
            ，
            {{ productionData.consignmentNum }}个挂售</span></span>
        <span v-if="productionData.worksId == 25 || productionData.worksId == 74">，{{ productionData.frozenNum
        }}个冻结</span>
      </p>
    </div>
  </div>
</template>

<script>
import { ossParameters, ossParameters1 } from '../../assets/js/globle.js'
export default {
  props: {
    attributes: {
      type: Object,
      default: function () {
        return {
          checked: false,
          editFlag: false
        }
      }
    },
    showFlag: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    portfolioInfoMine: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    productionData: {
      type: Object,
      default: function () {
        return {
          // img: img1,
          collected: false,
          checked: false,
          title: "Queen's Art",
          // headImg: headImg,
          user: 'Amber',
          platform: 'cun',
          price: 500
        }
      }
    }
  },
  data() {
    return {
      parameters: ossParameters(),
      parametersHead: ossParameters1(),
      production: this.productionData
    }
  },
  methods: {
    info() {
      // let userVO = JSON.parse(localStorage.getItem('userVO'))
      // if (this.productionData.userType == 0 && this.productionData.userId === userVO.userId) {
      //   this.$router.push({
      //     path: '/myPortfolioInfo',
      //     query: {
      //       worksId: this.production.worksId
      //     }
      //   })
      //   return
      // }
      if (this.portfolioInfoMine) {
        this.$router.push({
          path: '/portlioInfoBuyed',
          query: {
            worksId: this.production.worksId
          }
        })
      } else {
        this.$router.push({
          path: '/portfolioInfo',
          query: {
            worksId: this.production.worksId
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  width: 380px;
  height: 400px;
  position: relative;
  cursor: pointer;

  // &:hover {
  //   box-shadow: 0px 0px 20px 13px rgba(0, 0, 0, 0.09);
  //   transform: scale(1.01);
  // }
  @media screen and(max-width:768px) {
    width: 100%;
    height: 184px;
  }

  img {
    width: 100%;
    height: 236px;

    @media screen and(max-width:768px) {
      width: 100%;
      height: 103px;
    }
  }

  /deep/ .el-checkbox {
    position: absolute;
    top: 24px;
    left: 18px;

    .el-checkbox__label {
      color: #e8721d;
    }

    .is-checked {
      .el-checkbox__inner {
        background-color: #e8721d;
        border-color: #e8721d !important;
      }
    }

    .el-checkbox__inner {
      // background-color: #e8721d;
      border-color: #e8721d !important;
    }
  }

  .monban {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 2;
    flex-direction: column;
    width: 100%;
    height: 156px;
    background-color: rgba(255, 255, 255, 1);

    .head-img {
      position: relative;
      width: 58px;
      height: 58px;
      border-radius: 50%;
      top: -29px;
    }

    .name {
      position: relative;
      top: -29px;
      font-size: 18px;
      color: #525252;
      margin: 16px 0 6px 0;

      .v-icon {
        width: 16px;
        height: 16px;
        margin: 0 0 0 6px;
      }
    }

    .user {
      position: relative;
      top: -29px;
      font-size: 12px;
      color: #7b7b7b;
      font-weight: 400;
      margin-bottom: 18px;
    }

    .dis {
      position: relative;
      top: -29px;
      font-size: 14px;
      color: #7b7b7b;
      // margin-bottom: 50px;
      font-weight: 400;
      width: 80%;
      text-align: center;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      line-height: 18px;
      flex-shrink: 0;

      @media screen and(max-width:768px) {
        font-size: 9px;
      }
    }
  }
}

.checked {
  border: 5px solid #e8721d;
}
</style>



// WEBPACK FOOTER //
// src/conponents/portfolio/index.vue